import axios from 'axios'
import * as qs from 'qs'
import config from './config'
// 验证手机号
export function checkPhone(phone) {
  return /^1[345678]\d{9}$/.test(phone)
}

// 验证验证码
export function checkCode(code) {
  return /^\d{4}$/.test(code)
}

export async function pay(id, opt) {
  const { data } = await axios.get(`/api/mobile/other/setting/getSettings`, {
    params: {
      keys: 'erp_virtual',
      cat: 'ADMIN',
    }
  })
  const goodsList = data.erp_virtual && data.erp_virtual.knowlege
  const skuInfo = goodsList['' + id]
  const origin = config.env === 'production' ? 'https://m.ivydad.com' : 'http://m.ivydad.com.cn'
  if (skuInfo) {
    window.location.href = `${origin}/goods/goodsView?spuId=${skuInfo.spu_id}`
  } else {
    let href = window.location.href
    window.location.href = `//${window.location.host}/center/order/orderConfirm/?${qs.stringify({type: 'knowlege', from: 'knowlege', product_id: id, ...opt, redirect: href})}`
  }
}

export async function toCenterKnowledgeList() {
  window.location.href = `${window.location.origin}/center/index/knowlegeCourseList`
}

// 阿里云图片获取指定尺寸的图片
export function transAliImgResize(url, width, height, mode = 'mfit') {
  // return igorePrefex(`${url}?x-oss-process=image/resize,m_${mode},h_${height},w_${width}`)
  return `${url}?x-oss-process=image/resize,m_${mode},h_${height},w_${width}`
}

// 去掉网络协议请求头
export function igorePrefex(url) {
  return url.replace(/https?:(\/\/.+\.)/, '$1')
}


//  * 获取数据类型
//  * getType(5); // => "Number"
//  * getType({}); // => "Object"
//  * getType(/foo/); // => "RegExp"
//  * getType(''); // => "String"
//  * getType(true); // => "Boolean"
//  * getType([]); // => "Array"
//  * getType(undefined); // => "Window"
//  * getType(Element); // => "Constructor"
export function getType(object) {
  return Object.prototype.toString.call(object).match(/^\[object\s(.*)\]$/)[1]
}
